module.exports = __webpack_public_path__ + "jab/media/close.be85a997.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/close.svg
// module id = 31
// module chunks = 0